interface PaginationProps {
  postsPerPage: number;
  totalPosts: number;
  currentPage: number;
  setCurrentPage: React.Dispatch<React.SetStateAction<number>>;
}

type PageItem = number | "...";

const Pagination = ({
  postsPerPage,
  totalPosts,
  currentPage,
  setCurrentPage,
}: PaginationProps) => {
  const totalPages = Math.ceil(totalPosts / postsPerPage);

  if (totalPages <= 1) return null;

  const getPageItems = (): PageItem[] => {
    if (totalPages <= 7) {
      return Array.from({ length: totalPages }, (_, i) => i + 1);
    }

    const pagesSet = new Set<number>([1, 2, totalPages - 1, totalPages]);

    for (let i = currentPage - 1; i <= currentPage + 1; i++) {
      if (i > 2 && i < totalPages - 1) {
        pagesSet.add(i);
      }
    }

    const pages = Array.from(pagesSet).sort((a, b) => a - b);
    const pageItems: PageItem[] = [];

    for (let i = 0; i < pages.length; i++) {
      const page = pages[i];
      const prevPage = pages[i - 1];

      if (i > 0 && page - prevPage! > 1) {
        pageItems.push("...");
      }

      pageItems.push(page);
    }

    return pageItems;
  };

  const pageItems = getPageItems();

  return (
    <nav className="w-full mt-6">
      <div className="w-full overflow-x-auto">
        <ul className="flex items-center justify-center gap-2 min-w-max px-2">
          <li>
            <button
              type="button"
              onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
              disabled={currentPage === 1}
              className="min-w-[40px] h-9 px-3 rounded-md border text-sm disabled:bg-gray-100 disabled:text-gray-400 bg-white text-gray-700 hover:bg-gray-100"
            >
              Prev
            </button>
          </li>

          {pageItems.map((item, index) => (
            <li key={`${item}-${index}`}>
              {item === "..." ? (
                <span className="px-3 text-sm text-gray-500">...</span>
              ) : (
                <button
                  type="button"
                  onClick={() => setCurrentPage(item)}
                  className={`min-w-[40px] h-9 px-3 rounded-md border text-sm ${
                    currentPage === item
                      ? "bg-indigo-600 text-white"
                      : "bg-white text-gray-700 hover:bg-gray-100"
                  }`}
                >
                  {item}
                </button>
              )}
            </li>
          ))}

          <li>
            <button
              type="button"
              onClick={() => setCurrentPage((prev) => Math.min(prev + 1, totalPages))}
              disabled={currentPage === totalPages}
              className="min-w-[40px] h-9 px-3 rounded-md border text-sm disabled:bg-gray-100 disabled:text-gray-400 bg-white text-gray-700 hover:bg-gray-100"
            >
              Next
            </button>
          </li>
        </ul>
      </div>
    </nav>
  );
};

export default Pagination;
// const Pagination = ({
//   postsPerPage,
//   totalPosts,
//   currentPage,
//   setCurrentPage,
// }: PaginationProps) => {
//   const totalPages = Math.ceil(totalPosts / postsPerPage);

//   if (totalPages <= 1) return null;

//   const getPages = () => {
//     const pages = [];

//     const start = Math.max(currentPage - 1, 1);
//     const end = Math.min(currentPage + 1, totalPages);

//     if (start > 1) {
//       pages.push(1);
//       if (start > 2) pages.push("...");
//     }

//     for (let i = start; i <= end; i++) {
//       pages.push(i);
//     }

//     if (end < totalPages) {
//       if (end < totalPages - 1) pages.push("...");
//       pages.push(totalPages);
//     }

//     return pages;
//   };

//   const pages = getPages();

//   return (
//     <nav className="w-full flex justify-center mt-6 px-2">
//       <ul className="flex flex-wrap items-center justify-center gap-2 text-sm">
//         {/* Prev */}
//         <li>
//           <button
//             onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
//             disabled={currentPage === 1}
//             className="min-w-[36px] h-9 px-3 rounded-md border
//               disabled:bg-gray-100 disabled:text-gray-400
//               bg-white text-gray-700 hover:bg-gray-100"
//           >
//             Prev
//           </button>
//         </li>

//         {/* Pages */}
//         {pages.map((page, index) => (
//           <li key={index}>
//             {page === "..." ? (
//               <span className="px-2 text-gray-500">...</span>
//             ) : (
//               <button
//                 onClick={() => setCurrentPage(Number(page))}
//                 className={`min-w-[36px] h-9 px-3 rounded-md border
//                   ${
//                     currentPage === page
//                       ? "bg-indigo-600 text-white"
//                       : "bg-white text-gray-700 hover:bg-gray-100"
//                   }`}
//               >
//                 {page}
//               </button>
//             )}
//           </li>
//         ))}

//         {/* Next */}
//         <li>
//           <button
//             onClick={() =>
//               setCurrentPage((prev) => Math.min(prev + 1, totalPages))
//             }
//             disabled={currentPage === totalPages}
//             className="min-w-[36px] h-9 px-3 rounded-md border
//               disabled:bg-gray-100 disabled:text-gray-400
//               bg-white text-gray-700 hover:bg-gray-100"
//           >
//             Next
//           </button>
//         </li>
//       </ul>
//     </nav>
//   );
// };

// export default Pagination;
